<template>
  <Layout>
    <ModalWorkHistorySP
      ref="workHistory"
    />
    <div>
    <table class="table table-bordered table-sm info-instructions">
      <tbody>
      <tr>
        <td width="120px">作業分類</td>
        <td>
          <span>{{ zzWorkOrderType }}</span>
        </td>
      </tr>
      <tr>
        <td>作業名</td>
        <td>{{ workOrderName }}</td>
      </tr>
      <tr>
        <td>排出事業者</td>
        <td>{{ dischargerName }}</td>
      </tr>
      <tr>
        <td>排出事業者住所</td>
        <td>{{ dischargerAddress }}</td>
      </tr>
      <tr>
        <td>排出事業場</td>
        <td>{{ dischargerSiteName }}</td>
      </tr>
      <tr>
        <td>排出事業場住所</td>
        <td>{{ dischargerSiteAddress }}</td>
      </tr>
      <tr>
        <td>営業担当者</td>
        <td>{{ dischargerSiteUser }}</td>
      </tr>
      <tr>
        <td>現場担当者</td>
        <td>{{ dischargerSitePersonCharge }}</td>
      </tr>
      <tr>
        <td>連絡先</td>
        <td>{{ dischargerSiteTel }}</td>
      </tr>
      </tbody>
    </table>
    <ul class="tab-titles">
      <li :class="{ active: activeTab === item.value}" 
      :style="{backgroundColor: item.backgroupColor}" 
      @click="activeTab = item.value" 
      v-for="(item, index) in btnTabOptions">
      {{ item.text }}
    </li>
    </ul>
    <div class="tab-content" v-show="activeTab === 'waste'">
      <table class="table table-bordered table-waste table-sm">
        <tbody>
        <template v-for="(item, index) in this.data.work_order_json != undefined ? this.data.work_order_json.waste_or_service_by_work_order : []">
          <tr v-if="item.waste !== null || item.service !== null">
            <td
              :style="{
                'background-color': btnTabOptions.waste.backgroupColor,
                'width': '100px'
              }"
            >
             <router-link
                class="text-decoration-underline"
                target="_blank"
                :to="{ name: 'projects.sales.wastes.detail.daily-report',
                    params: {daily_report_id: getId(),  id: item.id},
              }"
              >
                {{ wasteAndServiceCD(item) }}
              </router-link>
              
            </td>
            <td>
              {{ wasteAndServiceCategoryName(item) }}
            </td>
            <td>
              {{ treatmentMethod(item) }}
            </td>
          </tr>
          <tr v-if="item.waste !== null || item.service !== null">
            <td
              :style="{
                'background-color': btnTabOptions.waste.backgroupColor
              }"
            >
            </td>
            <td>
              {{ vendorSitefTreatment(item) }}
            </td>
            <td>
              {{ wasteAndServiceZZ(item) }}
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
    <div class="tab-content" v-show="activeTab === 'preparations'">
      <table class="table table-bordered table-sm">
        <tbody>
        <tr>
          <td
            :style="{
                'background-color': this.btnTabOptions.preparations.backgroupColor,
                'width': '100px'
              }"
          >作業人数</td>
          <td>{{ numberOfStaff }}</td>
        </tr>
        <tr>
          <td
            :style="{
                'background-color': this.btnTabOptions.preparations.backgroupColor,
              }"
          >資格</td>
          <td>
            {{ quanlifications }}
          </td>
        </tr>
        <tr>
          <td
            :style="{
                'background-color': this.btnTabOptions.preparations.backgroupColor,
              }"
          >使用道具</td>
          <td>{{ implements }}</td>
        </tr>
        <tr>
          <td
            :style="{
                'background-color': this.btnTabOptions.preparations.backgroupColor,
              }"
          >レンタル品・特殊準備品</td>
          <td v-html="comment"></td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="tab-content" v-show="activeTab === 'work_order'">
      <table class="table table-bordered table-sm">
        <tbody>
        <tr>
          <td
            :style="{
              'background-color': this.btnTabOptions.work_order.backgroupColor,
              'width': '100px'
            }"
          >確認項目</td>
          <td>{{ checkLists }}</td>
        </tr>
        <tr>
          <td
            :style="{
              'background-color': this.btnTabOptions.work_order.backgroupColor,
            }"
          >使用車両</td>
          <td>
            {{ carType }}
          </td>
        </tr>
        <tr>
          <td
            :style="{
              'background-color': this.btnTabOptions.work_order.backgroupColor,
            }"
          >作業詳細・安全対策指示</td>
          <td v-html="workDetailComment"></td>
        </tr>
        <tr>
          <td
            :style="{
              'background-color': this.btnTabOptions.work_order.backgroupColor,
            }"
          >物品販売</td>
          <td>{{ productSalesComment }}</td>
        </tr>
        <tr>
          <td
            :style="{
              'background-color': this.btnTabOptions.work_order.backgroupColor,
            }"
          >標準移動時間（往復）</td>
          <td>{{ standardTravelHours }}</td>
        </tr>
        <tr>
          <td
            :style="{
              'background-color': this.btnTabOptions.work_order.backgroupColor,
            }"
          >標準作業時間</td>
          <td>{{ standardWorkingHours }}</td>
        </tr>
        <tr>
          <td
            :style="{
              'background-color': this.btnTabOptions.work_order.backgroupColor,
            }"
          >標準荷下ろし時間</td>
          <td>{{ standardUnloadingHours }}</td>
        </tr>
        <tr>
          <td
            :style="{
              'background-color': this.btnTabOptions.work_order.backgroupColor,
            }"
          >合計時間</td>
          <td>{{ standardTotalHours }}</td>
        </tr>
        <tr>
          <td
            :style="{
              'background-color': this.btnTabOptions.work_order.backgroupColor,
            }"
          >備考</td>
          <td>{{  remarks }}</td>
        </tr>
        </tbody>
      </table>
      <div>
        <AttachmentFiles
          v-if="this.data.work_order_json && this.data.work_order_json.attachments &&  this.data.work_order_json.attachments.length"
          :files="this.data.work_order_json.attachments"
          class="mt-5 mb-3"
        />
      </div>
    </div>
    <b-row>
      <b-col cols="6" class="d-flex justify-content-center mb-4">
        <b-button
          variant="primary"
          size="lg"
          @click="back"
        >
          <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
        </b-button>
      </b-col>
      <b-col cols="6" class="d-flex justify-content-center mb-4" v-if="data.work_order_json.id">
        <b-button
          variant="primary"
          size="lg"
          @click="openworkHistoryModal()"
        >
          <i class="fas fa-history"></i> 作業履歴
        </b-button>
      </b-col>
    </b-row>
  </div>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/main.vue";
import apiEndpoints from "@/services/apiEndpoints";
import {mapGetters} from "vuex";
import AttachmentFiles from "@/views/pages/project/sale/instruction/attachment_files.vue";
import ModalWorkHistorySP from "@/views/pages/daily_reports/modals/sp/ModalWorkHistory.vue";

export default {
  components: {
    Layout,
    AttachmentFiles,
    ModalWorkHistorySP,
  },
  data() {
    return {
      activeTab: 'work_order',
      btnTabOptions: {
        'work_order': {
          text: '作業指示',
          value: 'work_order',
          backgroupColor: '#2ec2e1'
        },
        'preparations': {
          text: '準備物',
          value: 'preparations',
          backgroupColor: '#f9812f'
        },
        'waste': {
          text: '廃棄物',
          value: 'waste',
          backgroupColor: '#f9db75'
        },
      },
      data: []
    }
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      var url = "";
      let params = {tmp: this.$route.query.tmp};
      if(this.dailyReportId){
       url = apiEndpoints.daily_report_detail(this.dailyReportId);
      }else{
       url = apiEndpoints.get_workorder_for_sp_schedule_detail(this.$route.params.work_order_id);
      }
      const sendApi = await this.$http.get(url, params);
      const {status, data} = sendApi;

      if (status && data.result) {
        this.data = data.result;
      }
      this.isLoading = false;
    },
    back() {
      if (this.$route.params?.previousRoute?.fullPath) {
        return this.$router.push({
          path: this.$route.params.previousRoute.fullPath
        });
      }
    },
    getId(){
      return this.$route.query.daily_report_id??0;
    },
    openworkHistoryModal() {
      this.$refs.workHistory.openModal(this.data.work_order_json.id, this.workOrderName);
    },
  },
  computed: {
    ...mapGetters("options", ["options_tables"]),
    dailyReportId() {
      return this.$route.query.daily_report_id != undefined ? this.$route.query.daily_report_id : null
    },
    zzWorkOrderType() {
      let zzWorkOrderTypes = this.options_tables.zz_work_order_types
      let zzWorkOrderTypeId = this.data.work_order_json ? this.data.work_order_json.zz_work_order_type_id : null
      if (zzWorkOrderTypes !== undefined && zzWorkOrderTypes.length !== 0) {
        let result = zzWorkOrderTypes.filter(value => {
          return value.id === zzWorkOrderTypeId;
        });
        if (result[0] === undefined) {
          return ''
        }
        return result[0]['work_order_type'];
      }
      return ''
    },
    workOrderName() {
      return this.data.work_order_json ? this.data.work_order_json.name : ''
    },
    dischargerName() {
      return this.data.work_order_json && this.data.work_order_json.case && this.data.work_order_json.case.discharger ? this.data.work_order_json.case.discharger.name : ''
    },
    dischargerAddress() {
      if (this.data.work_order_json && this.data.work_order_json.case && this.data.work_order_json.case.discharger) {
        return (this.data.work_order_json.case.discharger.address_1 === null ? '' : this.data.work_order_json.case.discharger.address_1)
        + (this.data.work_order_json.case.discharger.address_2 === null ? '' : this.data.work_order_json.case.discharger.address_2)
        + (this.data.work_order_json.case.discharger.address_3 === null ? '' : this.data.work_order_json.case.discharger.address_3)
        + (this.data.work_order_json.case.discharger.address_4 === null ? '' : this.data.work_order_json.case.discharger.address_4)
      }
      return ''
    },
    dischargerSiteName() {
      return this.data.work_order_json && this.data.work_order_json.case && this.data.work_order_json.case.discharger_site ? this.data.work_order_json.case.discharger_site.name : ''
    },
    dischargerSiteAddress() {
      if (this.data.work_order_json && this.data.work_order_json.case && this.data.work_order_json.case.discharger_site) {
        return (this.data.work_order_json.case.discharger_site.address_1 === null ? '' : this.data.work_order_json.case.discharger_site.address_1)
        + (this.data.work_order_json.case.discharger_site.address_2 === null ? '' : this.data.work_order_json.case.discharger_site.address_2)
        +  (this.data.work_order_json.case.discharger_site.address_3 === null ? '' : this.data.work_order_json.case.discharger_site.address_3)
        + (this.data.work_order_json.case.discharger_site.address_4 === null ? '' : this.data.work_order_json.case.discharger_site.address_4)
      }
      return ''
    },
    dischargerSitePersonCharge() {
      return this.data.work_order_json && this.data.work_order_json.case && this.data.work_order_json.case.discharger_site ?
        this.data.work_order_json.case.discharger_site.discharger_site_person_in_charge :
        ''
    },
    dischargerSiteUser() {
      return this.data.work_order_json && this.data.work_order_json.case && this.data.work_order_json.case.discharger_site 
      && this.data.work_order_json.case.discharger_site.user1 ?
        this.data.work_order_json.case.discharger_site.user1.user_name :
        ''
    },
    dischargerSiteTel() {
      return this.data.work_order_json && this.data.work_order_json.case && this.data.work_order_json.case.discharger_site ?
        this.data.work_order_json.case.discharger_site.tel :
        ''
    },
    wasteAndServiceCategoryName() {
      return function(item) {
        let category = item.service ? (item.service?.service_category ? item.service?.service_category.name_abbreviated : '') : (item.waste?.waste_category ? item.waste?.waste_category.name_abbreviated : '')
        return category + '-' + this.dischargerSiteName
      }
    },
    wasteAndServiceCD() {
      return function(item) {
        if (item.waste) {
          return item.waste?.waste_cd
        }
        return item.service?.service_cd
      }
    },
    vendorSitefTreatment() {
      return function(item) {
        return item.disposal_site && item.disposal_site.disposal_site_by_waste_category && item.disposal_site.disposal_site_by_waste_category.vendor_site_of_treatment ?
          item.disposal_site.disposal_site_by_waste_category.vendor_site_of_treatment.name_abbreviated : ''
      }
    },
    treatmentMethod() {
      return function(item) {
        let treatment = (item.disposal_site && item.disposal_site.disposal_site_by_waste_category && item.disposal_site.disposal_site_by_waste_category.zz_treatment_method ?
          item.disposal_site.disposal_site_by_waste_category.zz_treatment_method.treatment_method : '')
        let category = (item.waste && item.waste.waste_category ? item.waste.waste_category.name_abbreviated : '')
        let result = []
        if (category) result.push(category)
        if (treatment) result.push(treatment)
        return  result.join('、')
      }
    },
    wasteAndServiceZZ() {
      return function(item) {
        let result = []
        let zzManifestPreparation = (item.zz_manifest_preparation_roles && item.zz_manifest_preparation_roles.manifest_preparation_role != undefined ? "準備" + item.zz_manifest_preparation_roles.manifest_preparation_role : '');
        let zzManifestType = (item.zz_manifest_types && item.zz_manifest_types.manifest_type != undefined ? item.zz_manifest_types.manifest_type : '');
        let zzMeasurementSite = (item.zz_measurement_sites && item.zz_measurement_sites.measurement_site != undefined ? "計量" + item.zz_measurement_sites.measurement_site : '');
        let zzJwUnit = (item.zz_jw_units && item.zz_jw_units.jw_unit != undefined ? "単位" + item.zz_jw_units.jw_unit : '');
        let zzQuantityConfirmationUnit = (item.zz_quantity_confirmation_unit != undefined ? "数量確定方法:" + item.zz_quantity_confirmation_unit.jw_unit : '');
        if (zzManifestPreparation) result.push(zzManifestPreparation);
        if (zzManifestType) result.push(zzManifestType);
        if (zzMeasurementSite) result.push(zzMeasurementSite);
        if (zzJwUnit) result.push(zzJwUnit);
        if (zzQuantityConfirmationUnit) result.push(zzQuantityConfirmationUnit);

        return result.join('、')
      }
    },
    numberOfStaff() {
      return this.data.work_order_json ? this.data.work_order_json.number_of_staffs_delivered + '名' : ''
    },
    quanlifications() {
      let result = []
      if (this.data.work_order_json && this.data.work_order_json.qualifications) {
        for (const el of this.data.work_order_json.qualifications) {
          result.push(el.qualification + '×' + el.pivot.number_of_staffs)
        }
      }
      return result.join('、')
    },
    implements() {
      let result = []
      if (this.data.work_order_json && this.data.work_order_json.implements) {
        for (const el of this.data.work_order_json.implements) {
          result.push(el.implement + '×' + el.pivot.number_of_implements)
        }
      }
      return result.join('、')
    },
    comment() {
      return this.data.work_order_json ? this.data.work_order_json.rental_and_special_items_comment : ''
    },
    checkLists() {
      let result = []
      if (this.data.work_order_json && this.data.work_order_json.checklists) {
        for (const el of this.data.work_order_json.checklists) {
          result.push(el.checkup_work_item)
        }
      }
      return result.join('、')
    },
    carType() {
      let result = []
      if (this.data.work_order_json) {
        for (const el of this.data.work_order_json.car_types_by_work_order) {
          result.push(el.invoice_product_name)
        }
      }
      return result.join('、')
    },
    workDetailComment() {
      return this.data.work_order_json ? this.data.work_order_json.work_detail_and_safety_measure_comment : ''
    },
    productSalesComment() {
      return this.data.work_order_json ? this.data.work_order_json.product_sales_comment : ''
    },
    showHours() {
      return function(value) {
        var a = value;
        var fract = a * 10 % 10 /10;
        var integr = a - fract;
        let result = ''
        if (integr) result += integr + '時間'
        if (fract)  result += fract * 60 + '分'
        return result
      }
    },
    standardTravelHours() {
      if (!this.data.work_order_json || ! this.data.work_order_json.standard_travel_hours) return ''
      return this.showHours(this.data.work_order_json.standard_travel_hours)
    },
    standardWorkingHours() {
      if (!this.data.work_order_json || ! this.data.work_order_json.standard_working_hours) return ''
      return this.showHours(this.data.work_order_json.standard_working_hours)
    },
    standardUnloadingHours() {
      if (!this.data.work_order_json || ! this.data.work_order_json.standard_unloading_hours) return ''
      return this.showHours(this.data.work_order_json.standard_unloading_hours)
    },
    standardTotalHours() {
      if (!this.data.work_order_json || ! this.data.work_order_json.standard_total_hours) return ''
      return this.showHours(this.data.work_order_json.standard_total_hours)
    },
    remarks() {
      return this.data.work_order_json ? this.data.work_order_json.remarks : ''
    }
  }
};

</script>

<style lang="scss" scoped>
  .tab-titles {
    padding-left: 0px!important;
    text-align: center;
    li {
      display: inline-block;
      margin-right: 5px;
      cursor: pointer;
      border: 1px solid #eff2f7 !important;
      width: 30%;
      text-align: center;
      border-radius: 5px;
      color: #333;
      padding: 5px;
    }
  }

  .tab-titles li.active {
    font-weight: bold;
  }

  .info-instructions tbody tr td:nth-child(1) {
    background-color: #2cb57e;
  }
  .table-waste tbody tr {
    border-bottom-style: dotted !important;
    &:nth-child(even) {
      border-top-style: dotted !important;
    }
    td {
      border-bottom-style: dotted !important;
      border-top-style: dotted !important;
    }
  }
  td:nth-child(1) {
    color: #333;
  }
</style>
